import styles from "./header-opt.module.scss";
import Link from "next/link";
import Camera from "../Header/VideoCall/Camera";

const VideoCounselling = () => {

  return (
    <div className={styles.videoBtnContainer}>
      {/* Video Call Button */}
      <Link href="https://widget01.popin.to/share/12338" target="_blank"  className={styles.videoBtnWrapper} aria-label="Start video call">
        <Camera className={styles.videoIcon} />
      </Link>
    </div>
  );
};


export default VideoCounselling